// extracted by mini-css-extract-plugin
export default {"viewContent":"view-content-button_viewContent__NVOgK","viewButton":"view-content-button_viewButton__Pd7e6"};